const SystemTypeIdDocsExpiration = ['194', '280'];

export { SystemTypeIdDocsExpiration };
